import React from 'react'

function SearchField(props) {
    const {
        handleSearchSubmit,
        onSearchChanged,
        search
    } = props

    return <form onSubmit={handleSearchSubmit}>
        <div className="row">
            <div className={"col-12"} style={{display: 'flex'}}>
                <div style={{paddingRight: 0, flexGrow: 1}}>
                    <input type="text" name="search" onChange={onSearchChanged}
                           value={search} style={{height: 37}}
                           className="form-control" placeholder="Hae..."/>
                </div>
                <div style={{paddingLeft: 5}}>
                    <button type="submit" className="btn btn-sm btn-primary float-right px-3"
                            style={{width: '60px'}}><i className="fas fa-search"></i>
                    </button>
                </div>
            </div>
        </div>
    </form>
}

export default SearchField
